<template>
  <div
    :class="'audio-player ' + (episode && episode.uuid ? 'show' : '')"
    data-test="audioplayer">
    <div id="audio-progress">
      <el-slider
        :min="0"
        :class="{paused: !play}"
        :max="duration"
        v-model="current_time"
        :show-tooltip="false"
        @change="onSliderChange"/>
    </div>
    <div
      :class="{'mobile-expand': show_options}"
      class="fluid-container container player-content">
      <el-row
        type="flex"
        align="middle"
        class="flex-wrap">
        <el-col
          v-if="episode"
          :lg="9"
          :md="12"
          :sm="9"
          :xs="14">
          <div
            class="audio-data"
            @click="toogleOptions">
            <img
              v-if="episode.display_image_url || (episode.season && episode.season.podcast)"
              :src="episode.display_image_url || episode.season.podcast.image_url "
            >
            <div class="audio-title">
              <span data-test="titleepisode">{{ episode.title }}</span> <br >
              <small v-if="episode.show_title || episode && episode.season && episode.season.podcast">
                <router-link
                  v-if="episode && episode.season && episode.season.podcast && episode.season.podcast.uuid && episode.season.podcast.publisher"
                  :to="`/listen/${episode.season.podcast.publisher.slug}/${episode.season.podcast.slug}/${episode.season.podcast.uuid}`"
                  data-test="titlepodcast">{{ episode.show_title || episode.season.podcast.title }}</router-link>
                <small v-else>{{ episode.show_title || episode.season.podcast.title }}</small>
              </small>
            </div>
          </div>
        </el-col>
        <el-col
          :lg="6"
          :md="5"
          :sm="6"
          :xs="10"
          class="">
          <div class="primary-controls">
            <div class="m-a">
              <div
                class="custom-control"
                @click="rewind">
                <span class="backward-button">
                  <svg svg-inline="" data-test="btn-backward" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_player_rewind_svg__a" d="M10.5555556,4.09189383 L10.5555556,6.51851852 L5,3.25925926 L10.5555556,0 L10.5555556,2.45927863 C15.8199939,2.74114029 20,7.00438259 20,12.2222222 C20,17.6223398 15.5228475,22 10,22 C4.4771525,22 0,17.6223398 0,12.2222222 C0,9.68585618 0.992957552,7.29981024 2.74203015,5.49597216 C3.0586832,5.16940432 3.58613348,5.15566241 3.92012331,5.46527873 C4.25411313,5.77489506 4.26816736,6.29062421 3.95151431,6.61719205 C2.4931477,8.12122181 1.66666667,10.1072299 1.66666667,12.2222222 C1.66666667,16.7223202 5.39762709,20.3703704 10,20.3703704 C14.6023729,20.3703704 18.3333333,16.7223202 18.3333333,12.2222222 C18.3333333,7.90465829 14.8989066,4.37142208 10.5555556,4.09189383 Z M7.20891842,14.8684211 L7.20891842,11.1167341 L7.14633136,11.1167341 L6,11.9095816 L6,10.8434548 L7.20891842,10 L8.41783684,10 L8.41783684,14.8684211 L7.20891842,14.8684211 Z M11.0960358,15 C9.9925272,15 9.25465874,14.3353576 9.23818846,13.451417 L10.335109,13.451417 C10.3911079,13.8090418 10.7073373,14.0452092 11.105918,14.0452092 C11.5473215,14.0452092 11.8602567,13.7348178 11.8602567,13.2591093 C11.8602567,12.7732794 11.5440274,12.4493927 11.102624,12.4493927 C10.7666303,12.4493927 10.5294583,12.6045884 10.3779317,12.8508772 L9.31395174,12.8508772 L9.53794752,10 L12.7002409,10 L12.7002409,10.9649123 L10.4701653,10.9649123 L10.3812258,12.0951417 L10.4438128,12.0951417 C10.6282799,11.791498 10.9642736,11.5958165 11.4517938,11.5958165 C12.3543651,11.5958165 13,12.2807018 13,13.2287449 C13,14.2813765 12.2423672,15 11.0960358,15 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-42.000000, -544.000000) translate(42.000000, 544.000000) translate(2.000000, 1.000000)"><mask id="ic_player_rewind_svg__b" fill="white"><use xlink:href="#ic_player_rewind_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_player_rewind_svg__b)"><g transform="translate(-2.000000, -1.000000)"><rect width="24" height="24"/></g></g></g></g></g></g></svg>
                </span>
              </div>
              <div class="custom-control">
                <span

                  :class="'play-button' + (play || isLoadingMedia ? ' hide': '')"
                  @click="togglePlay">
                  <svg svg-inline="" data-test="btn-play" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32"><defs><path id="ic_player_play_button_white_svg__a" d="M4.07366776,23.4918816 C3.32323673,24.055262 2.33454166,24.1580738 1.48922358,23.7606311 C0.64390551,23.3631885 0.0741938339,22.5276617 0,21.576568 L0,2.42343202 C0.0741938339,1.47233833 0.64390551,0.636811484 1.48922358,0.239368861 C2.33454166,-0.158073762 3.32323673,-0.0552619568 4.07366776,0.508118427 L17.6455609,10.0846864 C18.2818055,10.5028126 18.6666667,11.2247063 18.6666667,12 C18.6666667,12.7752937 18.2818055,13.4971874 17.6455609,13.9153136 L4.07366776,23.4918816 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-88.000000, -496.000000) translate(88.000000, 496.000000) translate(6.666667, 4.000000)"><mask id="ic_player_play_button_white_svg__b" fill="white"><use xlink:href="#ic_player_play_button_white_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_player_play_button_white_svg__b)"><g transform="translate(-6.666667, -4.000000)"><rect width="32" height="32"/></g></g></g></g></g></g></svg>
                </span>
                <span

                  :class="'pause-button' + (!play || isLoadingMedia ? ' hide': '')"
                  @click="togglePlay">
                  <svg svg-inline="" data-test="btn-pause" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32"><defs><path id="ic_player_pause_svg__a" d="M1,0 L5.66666667,0 C6.21895142,-1.01453063e-16 6.66666667,0.44771525 6.66666667,1 L6.66666667,23 C6.66666667,23.5522847 6.21895142,24 5.66666667,24 L1,24 C0.44771525,24 2.02974496e-15,23.5522847 0,23 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z M13,0 L17.6666667,0 C18.2189514,-5.91980459e-16 18.6666667,0.44771525 18.6666667,1 L18.6666667,23 C18.6666667,23.5522847 18.2189514,24 17.6666667,24 L13,24 C12.4477153,24 12,23.5522847 12,23 L12,1 C12,0.44771525 12.4477153,1.01453063e-16 13,0 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-40.000000, -496.000000) translate(40.000000, 496.000000) translate(6.666667, 4.000000)"><mask id="ic_player_pause_svg__b" fill="white"><use xlink:href="#ic_player_pause_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_player_pause_svg__b)"><g transform="translate(-6.666667, -4.000000)"><rect width="32" height="32"/></g></g></g></g></g></g></svg>
                </span>
                <i :class="'el-icon-loading' + (!isLoadingMedia ? ' hide': '')"/>
              </div>
              <div
                class="custom-control"
                @click="forward">
                <span class="forward-button">
                  <svg svg-inline="" data-test="btn-forward" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_player_fastforward_svg__a" d="M9.44444444,4.09189383 L9.44444444,6.51851852 L15,3.25925926 L9.44444444,0 L9.44444444,2.45927863 C4.18000609,2.74114029 0,7.00438259 0,12.2222222 C0,17.6223398 4.4771525,22 10,22 C15.5228475,22 20,17.6223398 20,12.2222222 C20,9.68585618 19.0070424,7.29981024 17.2579699,5.49597216 C16.9413168,5.16940432 16.4138665,5.15566241 16.0798767,5.46527873 C15.7458869,5.77489506 15.7318326,6.29062421 16.0484857,6.61719205 C17.5068523,8.12122181 18.3333333,10.1072299 18.3333333,12.2222222 C18.3333333,16.7223202 14.6023729,20.3703704 10,20.3703704 C5.39762709,20.3703704 1.66666667,16.7223202 1.66666667,12.2222222 C1.66666667,7.90465829 5.10109343,4.37142208 9.44444444,4.09189383 Z M7.426144,12.8632479 L7.426144,12.0315582 L8.05563898,12.0315582 C8.49308464,12.0315582 8.78115862,11.8047337 8.78115862,11.4595661 C8.78115862,11.1143984 8.50019758,10.9007232 8.04496957,10.9007232 C7.5968545,10.9007232 7.29455465,11.1472715 7.28032878,11.5187377 L6.09602466,11.5187377 C6.113807,10.591716 6.88200427,10 8.07342132,10 C9.21149135,10 9.99391449,10.5292571 9.99391449,11.2952005 C9.99391449,11.8408941 9.59914645,12.2715319 9.0229985,12.3701512 L9.0229985,12.4326101 C9.73073579,12.5016437 10.1824073,12.9322814 10.1824073,13.5437212 C10.1824073,14.4017094 9.307516,15 8.05208251,15 C6.85355252,15 6.04623409,14.3951348 6,13.4648258 L7.24476409,13.4648258 C7.26254643,13.82643 7.57907216,14.0499671 8.07342132,14.0499671 C8.53576227,14.0499671 8.85584446,13.8067061 8.85584446,13.4516765 C8.85584446,13.086785 8.55354461,12.8632479 8.05563898,12.8632479 L7.426144,12.8632479 Z M12.8447799,15 C11.5111041,15 10.6895598,14.0598291 10.6895598,12.4884944 C10.6895598,10.9171598 11.5217735,10 12.8447799,10 C14.1642298,10 15,10.9138725 15,12.4917817 C15,14.0565417 14.1748992,15 12.8447799,15 Z M12.8447799,14.0729783 C13.3426855,14.0729783 13.6769936,13.5371466 13.6769936,12.4884944 C13.6769936,11.4464168 13.3426855,10.9270217 12.8447799,10.9270217 C12.3468743,10.9270217 12.0161227,11.4464168 12.0161227,12.4884944 C12.0161227,13.5371466 12.3468743,14.0729783 12.8447799,14.0729783 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-88.000000, -544.000000) translate(88.000000, 544.000000) translate(2.000000, 1.000000)"><mask id="ic_player_fastforward_svg__b" fill="white"><use xlink:href="#ic_player_fastforward_svg__a"/></mask><g fill="#FFFFFF" mask="url(#ic_player_fastforward_svg__b)" style="mix-blend-mode:screen"><g transform="translate(-2.000000, -1.000000)"><rect width="24" height="24"/></g></g></g></g></g></g></svg>
                </span>
              </div>
              <audio
                id="audio"
                ref="audio"
                :crossorigin="episode && episode.is_exclusive ? 'use-credentials' : null"
                controlsList="nodownload"
                preload="auto">
                <source
                  type="audio/mpeg">
              </audio>
            </div>
          </div>
        </el-col>
        <el-col
          :lg="9"
          :md="7"
          :sm="9"
          :xs="12"
          class="hidden-xs-only">
          <div class="secondary-controls">
            <div
              class="audio-time"
              data-test= "audiotime">
              {{ current_time | timeFormat }} / {{ duration | timeFormat }}
            </div>
            <div>
              <player-speed-changer
                player-id="audio"
                @speedChnage="setPlaybackRate"/>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row
        :class="'mobile-view hidden-sm-and-up' + (episode && episode.uuid ? ' show' : '')"
        type="flex"
        align="middle">
        <el-col
          :span="12"
          class="t-c">
          <div class="audio-time">
            {{ current_time | timeFormat }} / {{ duration | timeFormat }}
          </div>
        </el-col>
        <el-col
          :span="12"
          class="t-c">
          <div>
            <player-speed-changer player-id="audio"/>
          </div>
        </el-col>
        <!-- <el-col
          :span="6"
          class="t-c">
          <div>
            <img
              class="cursor-pointer"
              src="../assets/images/ic_up_next.svg"
              @click="tooglePlaylist">
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script>
/*
this.current_time: this should be in milliseconds
this.duration: this should be in milliseconds
this.$refs.audio.currentTime: this will be in seconds, have to convert accordingly
this.$refs.audio.duration: this will be in seconds, have to convert accordingly
*/

import Episode from '../services/Episode';
import Event from '../services/PlayerEvent';
import Playlist from './Playlist';
import PlaybackService from '../services/PlaybackService';
import User from '../services/User';
import PlayerSpeedComponent from './PlayerSpeed';

const saveProgressInterval = 10; // save play progress after 30 seconds
const progressInterval = saveProgressInterval * 3;

export default {
  name: 'AudioPlayerComponent',
  components: {
    playlist: Playlist,
    'player-speed-changer': PlayerSpeedComponent,
  },
  data() {
    return {
      // audio_src: "http://www.noiseaddicts.com/samples_1w72b820/4241.mp3",
      episode: null,
      playbackService: null,
      play: false,
      stopAutoplay: true,
      muted: false,
      current_time: 0,
      duration: 0,
      user_service: new User(),
      show_playlist: false,
      slider_direction: 'right',
      controlled_manipulation: false,
      show_options: false,
      playback_rate: 1,
      episode_data: null,
      eventProvider: new Event(),
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    isLoadingMedia() {
      const { status } = this.$store.getters;
      return status === 'loading';
    },
    currentlyPlayingItem() {
      return this.$store.getters.episode;
    },
    playing() {
      return this.$store.getters.play;
    },
    reloadNext() {
      return this.$store.getters.reloadNext;
    },
    isLastPlayed() {
      return this.$store.getters.isLastPlayed;
    },
  },
  watch: {
    currentlyPlayingItem(newVal, oldVal) {
      if (newVal && newVal.uuid !== oldVal.uuid) {
        // this.$store.dispatch('setStatus', 'loading');
        this.episode = newVal;
        // this.loadEpisodeIntoPlayer();
        // this.loadMediaInPlayer(this.episode.media_url, this.episode.is_exclusive);
        this.setUpAudioPlayerHooks();
      }
    },
    playing() {
      if (this.playing) {
        this.play = true;
      } else {
        this.play = false;
      }
      this.playOrPause();
    },
    '$store.getters.progress': function (newVal, oldVal) {
      if (newVal !== oldVal && newVal === 0) {
        this.replay();
      }
    },
    reloadNext(newVal) {
      if (newVal) {
        this.playbackService.fetchAndStoreNextEpisode(this.episode.uuid);
      }
    },
  },
  mounted() {
    const ctx = this;
    ctx.playbackService = new PlaybackService();
    this.play = this.$store.getters.play;
    window.eventBus.$on('hide-player', () => {
      if (this.play) {
        this.eventProvider.triggerEpisodePauseEvent(this.episode, 'log_out');
      }
      this.hidePlayer();
      this.updateAppStyle(true);
    });
    window.eventBus.$on('pause-podcast', () => {
      ctx.togglePlay();
      ctx.saveCurrentPlayingEpisodeId(null);
    });
  },
  methods: {
    togglePlay() {
      this.play = !this.play;
      if (this.play) {
        this.$store.dispatch('play');
        this.eventProvider.triggerEpisodePlayEvent(this.episode, 'resume_episode');
      } else {
        this.$store.dispatch('pause');
        this.eventProvider.triggerEpisodePauseEvent(this.episode);
      }
      // Last played episode will reload to avoid user permission / autoplay policy on safari.
      if (this.isLastPlayed === this.episode.uuid) {
        this.$store.dispatch('setIsLastPlayed', false);
        this.loadMediaInPlayer(this.episode.media_url, this.episode.is_exclusive);
      }
      // this.playOrPause();
    },
    playOrPause() {
      if (this.playback_rate) {
        this.$refs.audio.playbackRate = this.playback_rate;
      }
      if (this.play) {
        this.$refs.audio.play();
        // this.setMediaPlaybackNotification(this.episode.title, this.episode.show_title || (this.episode.season && this.episode.season.podcast) ? this.episode.season.podcast.title : '', this.episode.display_image_url || this.episode.season.podcast.image_url);
      } else {
        this.$refs.audio.pause();
      }
      this.saveCurrentPlayingEpisodeId(this.play ? this.episode.uuid : null);
    },
    rewind() {
      this.controlled_manipulation = true;
      this.$refs.audio.currentTime -= 15;

      this.savePodcastProgress();
      this.eventProvider.triggerRewindEvent(this.episode);
    },
    forward() {
      this.controlled_manipulation = true;
      this.$refs.audio.currentTime += 30;

      this.savePodcastProgress();
      this.eventProvider.triggerForwardEvent(this.episode);
    },
    toggleMute() {
      this.muted = !this.muted;

      this.$refs.audio.muted = this.muted;
    },
    checkLastPlayProgress() {
      // TODO: Progress should be in episode data to avoid this extra api call
      if (!this.isLoggedIn) {
        // this.restartPlay();
        this.savePodcastProgress();
        return;
      }
      const episodeProvider = new Episode();
      episodeProvider.getEpisodeProgress(this.episode.uuid).then(this.checkLastPlayProgressResponse)
        .catch(() => {
          this.restartPlay();
          this.savePodcastProgress();
        });
    },
    checkLastPlayProgressResponse(resp) {
      if (!resp || !resp.elapsed) {
        this.restartPlay();
        this.savePodcastProgress();
      } else {
        // const pos = resp.elapsed / 1000; // converting last save position into seconds
        const pos = resp.elapsed;
        if (resp && resp.progress_percent > 95) {
          this.restartPlay();
        } else {
          if (this.stopAutoplay) {
            this.pause = true;
          } else {
            this.pause = false;
          }
          this.play = this.$store.getters.play;
          this.setDuration(pos, this.pause, false);
        }
      }
    },
    restartPlay() {
      if (this.$refs.audio) {
        this.$refs.audio.currentTime = 0;

        this.current_time = 0;
        this.duration = this.$refs.audio.duration * 1000;
        this.$refs.audio.load();
        if (!this.stopAutoplay) {
          this.$refs.audio.play();
          this.play = this.$store.getters.play;
        }
      }
    },
    setDuration(duration, pause, seeking = true) {
      if (this.$refs.audio) {
        // this.$store.dispatch('setStatus', 'loading');
        this.$store.dispatch('setSeeking', seeking);

        const currentProgress = this.$refs.audio.currentTime;
        this.current_time = duration;
        // this.$refs.audio.load();
        this.$refs.audio.currentTime = duration / 1000;
        this.updateProgressSlider();
        if (pause) {
          this.$refs.audio.pause();
          this.play = false;
        }
        if (seeking && !pause && this.play) {
          this.savePodcastProgress();
          this.eventProvider.triggerScrubEvent(this.episode, currentProgress * 1000, this.$refs.audio.currentTime * 1000);
        }
      }
    },
    mediaPlayingListener() {
      if (this.$refs.audio) {
        const ctx = this;
        this.$refs.audio.oncanplaythrough = () => {
          // ctx.audio_loading = false;
          // ctx.checkLastPlayProgress()
          if (ctx.play && ctx.episode) {
            ctx.playOrPause();
            // ctx.broadcastCurrentEpisodeId()
            ctx.saveCurrentPlayingEpisodeId(ctx.episode.uuid);
            ctx.savePodcastProgress();
          }
        };
      }
    },
    mediaLoadedListener() {
      if (this.$refs.audio) {
        const ctx = this;
        this.$refs.audio.onloadedmetadata = () => {
          ctx.duration = ctx.$refs.audio.duration * 1000;
          // TODO: // Set episode progress
          const episodeProvider = new Episode();
          const listenedProgress = episodeProvider.getEpisodeProgressFromLocalStore(ctx.episode.uuid);
          const { status, canPlay, seeking } = this.$store.getters;
          if (status !== 'loaded') {
            ctx.$store.dispatch('setStatus', 'loaded');

            // This condition prevents the player from autoplaying on a page load/refresh or when seeking from a paused state
            if (canPlay) {
              ctx.$store.dispatch('play', true);
            }

            // TODO: Save current podcast as active podcast
            ctx.$store.dispatch('setContinuousListeningActivePodcast',
              (ctx.episode.season && ctx.episode.season.podcast) ? ctx.episode.season.podcast.uuid : null);
            ctx.$store.dispatch('setContinuousListeningActiveEpisode', ctx.episode);
            // TODO: fetch next episode and save in store
            if (!seeking || ctx.$store.getters.status === 'loaded') {
              const playProgress = listenedProgress && listenedProgress.elapsed
                ? listenedProgress.elapsed : 0;
              const duration = ctx.$refs.audio.duration ? Math.floor(ctx.$refs.audio.duration * 1000) : 0;
              if (listenedProgress && listenedProgress.progress_percent >= 95) {
                this.restartPlay();
              } else {
                ctx.setDuration(playProgress, false);
              }
              const episodeUuid = ctx.episode.uuid;
              const episodeType = ctx.episode.episode_type;
              const podcastUuid = (ctx.episode.season && ctx.episode.season.podcast) ? ctx.episode.season.podcast.uuid : null;
              if (ctx.episode && ctx.episode.episode_type !== 'trailer') {
                episodeProvider.savePlayProgress(episodeUuid, playProgress, duration, podcastUuid, episodeType).then(() => {
                  ctx.playbackService.fetchAndStoreNextEpisode(ctx.episode.uuid);
                }).catch(() => {
                  ctx.playbackService.fetchAndStoreNextEpisode(ctx.episode.uuid);
                });
              }
            }

            this.$store.dispatch('setSeeking', false);
          }
        };
      }
    },
    mediaLoadErrorListener() {
      if (this.$refs.audio && !this.$refs.audio.onerror) {
        const ctx = this;
        this.$refs.audio.onerror = () => {
          ctx.$store.dispatch('setStatus', 'failed');
        };
      }
    },
    onTrackEndListener() {
      if (this.$refs.audio) {
        const ctx = this;
        this.$refs.audio.onended = () => {
          ctx.$refs.audio.currentTime = 0;
          ctx.play = false;
          ctx.$store.dispatch('pause');
          ctx.stopAutoplay = false;
          ctx.savePodcastProgress();
          ctx.markPlaylistCurrentEpisode();
          ctx.$store.dispatch('setStatus', 'ended');
          ctx.$store.dispatch('setSeeking', false);
          this.loadNextEpisode();
          this.eventProvider.triggerEpisodePauseEvent(this.episode, 'episode_complete');
        };
      }
    },
    async markPlaylistCurrentEpisode() {
      const currentEpisodeID = this.$store.getters.currentPlaylingEpisodeId;
      const { playlist } = this.$store.getters;
      const targetIndex = playlist.findIndex(episode => episode.uuid === currentEpisodeID);
      if (targetIndex > -1 && targetIndex < playlist.length) {
        playlist[targetIndex].episode_listen = !playlist[targetIndex].episode_listen ? {
          progress_percent: 99,
        } : playlist[targetIndex].episode_listen;
      }
      this.$store.dispatch('setPlaylist', playlist);
    },
    onProgressListener() {
      let progress = 0;
      const ctx = this;
      this.$refs.audio.ontimeupdate = () => {
        let currentTime = (ctx.current_time / 1000);
        if (ctx.$refs.audio) {
          currentTime = ctx.$refs.audio.currentTime || 0;
        }

        if (ctx.slider_direction === 'right' && ctx.current_time < (currentTime * 1000)) {
          ctx.current_time = currentTime * 1000;
        } else if (ctx.slider_direction === 'left' && ctx.current_time < (currentTime * 1000)) {
          //
        } else if (ctx.current_time > (currentTime * 1000) && ctx.controlled_manipulation) {
          ctx.current_time = currentTime * 1000;
          ctx.controlled_manipulation = false;
        }

        ctx.updateProgressSlider();

        progress++;

        if (progress % progressInterval === 0) {
          if (ctx.isLoggedIn) { ctx.savePodcastProgress(); }
          ctx.eventProvider.triggerHeartbeatEvent(this.episode);
        }
      };
    },
    onSliderChange(value) {
      const { play } = this.$store.getters;
      this.setDuration(value, !play);
    },
    savePodcastProgress() {
      const ctx = this;
      if (ctx.$refs.audio && ctx.isLoggedIn) {
        const playProgress = ctx.$refs.audio.currentTime ? Math.floor(ctx.$refs.audio.currentTime * 1000) : 0;
        let audioDuration = this.duration ? Math.floor(this.duration) : 0;
        if (!audioDuration) {
          audioDuration = ctx.episode.estimated_runtime ? ctx.episode.estimated_runtime : ctx.episode.runtime;
        }
        const duration = audioDuration;
        const episodeUuid = ctx.episode.uuid;
        const episodeType = ctx.episode.episode_type;
        const podcastUuid = (ctx.episode.season && ctx.episode.season.podcast) ? ctx.episode.season.podcast.uuid : null;

        const episodeProvider = new Episode();
        if (this.episode && this.episode.episode_type && this.episode.episode_type === 'trailer') {
          return;
        }
        if (playProgress) {
          const progressPercent = parseFloat(((playProgress / duration) * 100).toFixed(2));
          episodeProvider.savePlayProgress(episodeUuid, playProgress, duration, podcastUuid, episodeType);
          this.$store.dispatch('setProgress', playProgress);
          this.$store.dispatch('setEpisodeProgressById', {
            runtime: ctx.episode.runtime,
            episode_uuid: ctx.episode.uuid,
            elapsed: playProgress,
            progress_percent: progressPercent > 100 ? 100 : progressPercent,
          });
        }
      }
    },
    updateProgressSlider() {
      // const completed = (this.duration / this.current_time) * 100;
      const sliderProgressBar = document.getElementsByClassName('el-slider__bar')[0];
      const sliderControl = document.getElementsByClassName('el-slider__button-wrapper')[0];
      if (sliderProgressBar && sliderControl && this.duration > 0) {
        sliderProgressBar.style.width = `${(this.current_time / this.duration) * 100}%`;
        sliderControl.style.left = `${(this.current_time / this.duration) * 100}%`;
      }
    },
    updateAppStyle(hide = false) {
      const app = document.getElementById('app');
      const body = document.querySelector('body');

      if (!app) return;

      if (app.classList && !this.isNull(app.classList.value) && app.classList.value.indexOf('audio-player-visible') < 0 && !hide) {
        app.classList.add('audio-player-visible');
      } else {
        // app.classList.remove('audio-player-visible');
      }

      if (body.classList && !this.isNull(body.classList.value) && body.classList.value.indexOf('audio-player-visible') < 0 && !hide) {
        body.classList.add('audio-player-visible');
      } else {
        // body.classList.remove('audio-player-visible');
      }
    },
    isNull(value) {
      if (value === null || typeof value === 'undefined') {
        return true;
      } return false;
    },
    saveCurrentPlayingEpisodeId(id) {
      this.$store.dispatch('setCurrentPlayingEpisodeId', id); // save currently playing episode in store
    },
    tooglePlaylist() {
      this.show_playlist = !this.show_playlist;
    },
    toogleOptions() {
      this.show_options = !this.show_options;
    },
    setPlaybackRate(rate) {
      this.playback_rate = rate;
      this.$store.dispatch('setPlaybackSpeed', parseFloat(rate));
      this.eventProvider.triggerPlaybackSpeedEvent(this.playback_rate, this.current_time);
    },
    broadcastCurrentEpisodeId() {
      // catch this event anywhere where want to get current playing episode
      this.$eventHub.$emit('play-podcast', {
        uuid: this.episode.uuid,
        play: this.play,
      });
    },
    broadcastCurrentPodcastLoaded() {
      this.$eventHub.$emit('loaded-podcast', {
        uuid: this.episode.uuid,
      });
    },
    setUpAudioPlayerHooks() {
      const ctx = this;
      setTimeout(() => {
        ctx.checkLastPlayProgress(); // Check if played progress of current episode
        ctx.broadcastCurrentPodcastLoaded(); // Broad cast current episode is loaded
        ctx.mediaLoadedListener(); // watch when podcast loaded to show duration
        ctx.mediaLoadErrorListener(); // watch for media loading fail
        ctx.mediaPlayingListener(); // watch when podcast is ready to play
        ctx.onTrackEndListener(); // watch when podcast end
        ctx.onProgressListener(); // watch when podcast progress change to save progress after specific interval
        ctx.updateAppStyle();
        ctx.saveCurrentPlayingEpisodeId(this.episode.uuid);
        // Detect drag left or right on progress slider

        const dragButton = document.getElementsByClassName('el-slider__button-wrapper')[0];
        let oldPos = 0;
        let lastVal = 0;

        dragButton.addEventListener('mousemove', (e) => {
          if (oldPos <= e.clientX) {
            ctx.slider_direction = 'right';
            oldPos = e.clientX;
            lastVal = ctx.current_time;
          } else if (oldPos >= e.clientX) {
            if (lastVal > ctx.current_time) {
              ctx.slider_direction = 'left';
              oldPos = e.clientX;
              lastVal = ctx.current_time;
            }
          }
        }, false);
        ctx.mediaSeekEvents();
      });
    },
    hidePlayer() {
      const ctx = this;
      if (ctx.$refs.audio) {
        ctx.$refs.audio.pause();
        ctx.$refs.audio.oncanplaythrough = null;
        ctx.$refs.audio.onloadedmetadata = null;
        ctx.$refs.audio.ontimeupdate = null;
        ctx.episode = null;
      }
    },
    replay() {
      if (this.$refs.audio) {
        this.$refs.audio.currentTime = 0;
        this.current_time = 0;
        this.playOrPause();
      }
    },
    loadNextEpisode() {
      const { nextEpisode, playlistType } = this.$store.getters;
      if (nextEpisode && nextEpisode.uuid) {
        this.playbackService.syncCLBucketWithPlayerLocally(nextEpisode);
        setTimeout(() => {
          if (this.episode.season.podcast.uuid !== nextEpisode.season.podcast.uuid && playlistType === 'continue-listening') {
            this.$store.dispatch('setAllCaughtUp', this.episode.season.podcast.uuid);
            this.$store.dispatch('setContinuousListeningActivePodcast', nextEpisode.season.podcast.uuid);
          }
          this.$store.dispatch('setAndPlayEpisode', { ...nextEpisode });
          this.loadMediaInPlayer(nextEpisode.media_url, nextEpisode.is_exclusive);
          this.eventProvider.triggerEpisodePlayEvent(nextEpisode, 'auto_play');
        }, 1000);
      } else {
        this.$store.dispatch('setAllCaughtUp', this.episode.season.podcast.uuid);
      }
    },
    mediaSeekEvents() {
      if (this.$refs.audio) {
        const ctx = this;
        this.$refs.audio.onseeking = () => {
          ctx.$store.dispatch('setSeeking', true);
          ctx.$store.dispatch('setStatus', 'loading');
        };
        this.$refs.audio.onseeked = () => {
          ctx.$store.dispatch('setSeeking', false);
          ctx.$store.dispatch('setStatus', 'loaded');
        };
      }
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/variables.scss";

.audio-player.show {
  visibility: visible;
}
.el-tooltip__popper.is-dark.up-next{
  z-index: 10000 !important;
}

.audio-player {
  position: fixed;
  bottom: 0;
  left:0;
  width: 100%;
  color: $white;
  background: linear-gradient(137.97deg, #272727 0%, #304145 100%);
  z-index: 9990;
  visibility: hidden;
  .player-content {
    height: 64px;
    transition: height 0.25s linear;
  }
  .audio-data {
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
      min-width: 40px;
      background: lightgray;
      margin-right: 1rem;

    }

    .audio-title {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      font-family: Favorit;
      letter-spacing: 0.4px;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      padding: 12px 0px;
      small, a{
        font-size: 14px;
        font-weight: normal;
        line-height: 18px;
        color: #BABABA;
      }
    }
  }

  .primary-controls {
    width: 100%;
    height: 3.35rem;
    display: flex;
    align-items: center;
    height: 3.35rem;

    .custom-control {
      width: 3.25rem;
      text-align: center;
      display: inline-block;
      cursor: pointer;

      i {
        font-size: 1.8rem;
        cursor: pointer;
        vertical-align: bottom;
        margin-bottom: 8px;
      }

      i.hide, span.hide {
        display: none;
      }
      .play-button{
        svg {
          width: 32px;
          height: 32px;
        }
      }
      .pause-button{
        svg {
          width: 29px;
          height: 29px;
        }
      }
      .backward-button, .forward-button{
        svg {
          width: 24px;
          height: 24px;
          padding: 4px 0px;
        }
      }
    }
  }
  .secondary-controls{
    text-align: right;
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;

    > div{
      display: inline-block;
      padding: 0.5rem 24px;
      border-right: 1px solid #666666;
    }
    > div:last-child{
      display: inline-block;
      border-right: 0px solid #666666;
      padding-top: 0px;
      padding-bottom: 0px;
      padding-right: 0px;
      vertical-align: middle;

      img{
        width: 24px;
      }
    }

    .audio-time {
      width: auto;
      text-align: center;
      color: #bbbbbb;
    }
    .now-playing{
      cursor: pointer;
    }
  }
  .mobile-view{

    border-top: 1px solid #666666;
    font-size: 14px;
    font-weight: normal;
    line-height: 10px;
    visibility: hidden;
    height: 0px;
    transition: all 0.2s ease-out;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;

    > div{
      padding: 0.5rem 1rem;
      border-right: 1px solid #666666;
    }

    > div:last-child{
      border-right: 0px;
      img{
        width: 24px;
      }
    }

    .audio-time {
      width: 147px;
      text-align: center;
      color: #bbbbbb;
    }
  }
  .mobile-view.show{
    padding: 0.75rem 0px;
    visibility: visible;
    height: 64px;
  }
  #audio-progress {
    margin: 0;
    flex-grow: 1;
    position: relative;
    height: 6px;
    .el-slider.paused{
      .el-slider__runway{
        .el-slider__button-wrapper:hover{
          .el-slider__button.el-tooltip{
            background-color: #666666;
            border-color: #666666;
          }
        }
      }
    }
    .el-slider__runway{
      background-color: #bababa;
      margin: 0px;
      height: 6px;
      .el-slider__button-wrapper{
        .el-slider__button.el-tooltip{
          width: 10px;
          height: 10px;
          background-color: transparent;
          border-color: transparent
        }
      }
      .el-slider__button-wrapper:hover{
        .el-slider__button.el-tooltip{
          background-color: #00AECB;
          border-color: #00AECB
        }
      }

      .el-slider__bar {
      background-color: #00AECB;
      height: 6px;
    }
    }
    .paused{
      .el-slider__bar {
      background-color: #666666 !important;
      height: 6px;
    }
    }
  }
  .up-next-playlist{
    visibility: hidden;
    height: 0px;
    transition: all 0.5s ease-out;
    -webkit-transition: all 0.5s ease-out;
    -moz-transition: all 0.5s ease-out;
    -o-transition: all 0.5s ease-out;
    transition: all 0.5s ease-out;
  }
  .up-next-playlist.show{
    visibility: visible;
    height: 386px;
  }
}

@media (max-width: 1024px) {
  .audio-player{
    .secondary-controls{
      > div{
        padding: 0.5rem 24px;
      }
    }
  }
}

@media (max-width: 992px) and (min-width: 768px)  {
  .audio-player{
    .audio-data{
      .audio-title{
        width: 60%;
      }
    }
    .secondary-controls{
      text-align: right;
      > div{
        padding: 0.5rem 24px 0.5rem 18px;
      }
      .audio-time {
        width: auto;
        padding-left: 0px
      }
    }
    .up-next-playlist.show{
      height: 384px;
    }
  }
}

@media (max-width: 768px) {
  .audio-player{
    .audio-data {
      img {
        width: 40px;
        height: 40px;
      }
    }
    .primary-controls > div {
      margin-right: 0px;
    }
    .player-content.mobile-expand {
      height: 125px;
    }
  }
}

@media (max-width: 567px) {
  .audio-player{
    .audio-data {
      img {
        width: 48px;
        height: 40px;
      }
    }
    .primary-controls > div{
      margin-right: 0;
    }
    .up-next-playlist.show{
      height: 344px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// app/src/components/AudioPlayer.vue